module.exports = __webpack_public_path__ + "img/dashboard-prices.4a209a2f.svg";